export default function GenerateBar({
  viewName, onViewNameChange,
  description, onDescriptionChange,
  prompt, onPromptChange,
  onGenerate, onSave, onDelete,
  isGenerating, isSaving, isConverting,
  hasYaml, hasSelected, canDelete = true,
}) {
  const busy = isGenerating || isSaving || isConverting

  return (
    <div className="generate-bar">
      {/* 첫 줄: 뷰 이름 + 버튼 */}
      <div className="generate-row">
        <label>뷰 이름</label>
        <input
          className="field field-name"
          value={viewName}
          onChange={e => onViewNameChange(e.target.value)}
          placeholder="my_metric_view"
          disabled={isGenerating}
        />

        <div className="btn-actions">
          <button
            className="btn-primary"
            onClick={onGenerate}
            disabled={busy || !viewName.trim()}
            title="Gemini로 Metric View 생성"
          >
            {isGenerating ? '생성 중...' : '▶ 생성'}
          </button>

          <button
            className="btn-secondary"
            onClick={onSave}
            disabled={busy || !hasYaml || !viewName.trim()}
            title="현재 뷰 저장"
          >
            {isSaving ? '저장 중...' : '저장'}
          </button>

          {/* KBNL-141(리뷰): 본인 항목만 삭제 노출 — 타인 SV 선택 시 삭제 숨김 */}
          {hasSelected && canDelete && (
            <button
              className="btn-danger"
              onClick={onDelete}
              disabled={busy}
              title="현재 뷰 삭제"
            >
              삭제
            </button>
          )}
        </div>
      </div>

      {/* 둘째 줄: 설명 */}
      <div className="generate-row">
        <label>설명</label>
        <textarea
          className="field field-desc"
          value={description}
          onChange={e => onDescriptionChange(e.target.value)}
          placeholder="이 뷰에 대한 설명 (예: 월별 매출 분석용 뷰)"
          disabled={isGenerating}
        />
      </div>

      {/* 셋째 줄: 생성 프롬프트 */}
      <div className="generate-row">
        <label>생성 프롬프트</label>
        <textarea
          className="field field-prompt"
          value={prompt}
          onChange={e => onPromptChange(e.target.value)}
          placeholder="Gemini에게 전달할 생성 지시사항 (선택사항)"
          disabled={isGenerating}
        />
      </div>
    </div>
  )
}
